import React from 'react';
import SalesForm from '../containers/SalesFormContainer';

const SalesFormAppClient = (props) => (
  <SalesForm {...props} />
);

export default SalesFormAppClient;
